import i18next from 'i18next'
import {
  addDropdownListener,
  addClickoutListener,
  deleteDropdownListener,
  deleteClickOutListener,
  setChangedLanguageCallback,
} from '../language-selector/LanguageSelector'
import { TranslationService } from 'services/translation'
import { MEDIAQUERIES } from '../constants'

let menuHandler, menu, menuWrapper, langSelector, navbar
let isMenuOpened = false

const MENU_SELECTOR = '.o-menu'
const ICON_SELECTOR = '.o-menu__icon'
const MENU_WRAPPER_SELECTOR = '.o-menu__wrapper'
const NAVBAR_SELECTOR = '.o-navbar-fluid'
const LANG_CONTENT_SELECTOR = '.o-lang-selector__content'

const OPEN_NAVBAR_CLASS = 'o-navbar-fluid--open'
const BLOCK_SCROLL_CLASS = 'block_scroll'
const MENU_HIDDEN_CLASS = 'o-menu--hidden'
const MENU_WRAPPER_LANG_CLASS = 'o-menu__wrapper--language'
const LANG_CONTENT_SELECTOR_OPEN_CLASS = 'o-lang-selector__content--opened'

const hamburguerIcon = 'ic-hamburger-28'
const closeIcon = 'ic-close-16'
const backIcon = 'ic-back-28'

let mediaQuery

const MenuHandler = {
  init() {
    langSelector = document.querySelector(LANG_CONTENT_SELECTOR)
    menu = document.querySelector(MENU_SELECTOR)
    menuWrapper = document.querySelector(MENU_WRAPPER_SELECTOR)
    menuHandler = document.querySelector(ICON_SELECTOR)
    navbar = document.querySelector(NAVBAR_SELECTOR)
    menuHandler.addEventListener('click', menuSelectorHandler)
    window.addEventListener('resize', handleResize)
    mediaQuery = window.matchMedia(MEDIAQUERIES.LARGEVIEWPORT)
  },
}

const handleResize = () => {
  if (mediaQuery.matches) {
    return closeMobileMenu()
  }
}

const menuSelectorHandler = () => {
  if (isMenuOpened) {
    return closeMobileMenu()
  }
  return openMobileMenu()
}

const closeMobileMenu = () => {
  isMenuOpened = false
  document.body.classList.remove(BLOCK_SCROLL_CLASS)
  navbar.classList.remove(OPEN_NAVBAR_CLASS)
  changeMenuIcon(closeIcon, hamburguerIcon)
  resetCurrentLanguageText()
  addDropdownListener()
  addClickoutListener()
}

const openMobileMenu = () => {
  isMenuOpened = true
  document.body.classList.add(BLOCK_SCROLL_CLASS)
  navbar.classList.add(OPEN_NAVBAR_CLASS)
  changeMenuIcon(hamburguerIcon, closeIcon)
  setCurrentLanguageText()
  deleteDropdownListener()
  deleteClickOutListener()
  addMobileLanguageHandler()
}

const setCurrentLanguageText = () => {
  const currentLanguageText = i18next.t(
    `languages.${TranslationService.getCurrentLanguage()}`,
  )
  langSelector.children[0].innerHTML = `${i18next.t(
    'languages_select_mobile_resolution',
  )} (${currentLanguageText})`
  setChangedLanguageCallback(closeMobileMenu)
}

const resetCurrentLanguageText = () => {
  const currentLanguageText = i18next.t(
    `languages.${TranslationService.getCurrentLanguage()}`,
  )
  langSelector.children[0].innerHTML = `${currentLanguageText}`
  setChangedLanguageCallback(null)
}

const changeMenuIcon = (iconToRemove, iconToAdd) => {
  menuHandler.classList.remove(iconToRemove)
  menuHandler.classList.add(iconToAdd)
}

const addMobileLanguageHandler = () => {
  langSelector.addEventListener('click', mobileLanguageHandler)
}

const mobileLanguageHandler = () => {
  menu.classList.add(MENU_HIDDEN_CLASS)
  menuWrapper.classList.add(MENU_WRAPPER_LANG_CLASS)
  langSelector.classList.add(LANG_CONTENT_SELECTOR_OPEN_CLASS)
  changeMenuIcon(closeIcon, backIcon)
  menuHandler.removeEventListener('click', menuSelectorHandler)
  menuHandler.addEventListener('click', menuBackHandler)
}

const menuBackHandler = () => {
  changeMenuIcon(backIcon, closeIcon)
  menu.classList.remove(MENU_HIDDEN_CLASS)
  menuWrapper.classList.remove(MENU_WRAPPER_LANG_CLASS)
  langSelector.classList.remove(LANG_CONTENT_SELECTOR_OPEN_CLASS)
  menuHandler.removeEventListener('click', menuBackHandler)
  menuHandler.addEventListener('click', menuSelectorHandler)
}

export { MenuHandler }
